import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileSkillsListService {
  /** Use to read 'middle dot' to a screenreader over other unicode dots */
  public static middleDotText: string = ' · ';

  private i18n = this.translateService.instant([
    'Core_Private',
    'Core_LimitedVisibility',
  ]);

  constructor(private translateService: TranslateService) {}

  public getLevelText(level): string {
    const params = { Level: level };
    return level
      ? ` ${this.translateService.instant('dgTagRating_Level', params)}.`
      : '';
  }

  public getPrivacyText(
    level,
    isOwner,
    shouldShowLock,
    isParticipantInTeamProgram
  ): string {
    const {
      Core_Private,
      Core_LimitedVisibility,
    } = this.i18n;

    // empty if there's no level value or the user is not the owner or
    // showing the lock icon is disabled
    if (!level || !isOwner || !shouldShowLock) {
      return '';
    }

    // otherwise check the user's participation and either return private or limited
    return !isParticipantInTeamProgram ? Core_Private : Core_LimitedVisibility;
  }

  public getTooltipText(baseText, privacyText) {
    // doing the privacy decorating here so the punctuation can be different from the screenreader version
    const privacyTextFormatted = privacyText
      ? `${ProfileSkillsListService.middleDotText}${privacyText}`
      : '';
    return baseText + privacyTextFormatted;
  }

  public getAriaLabelText(baseText, privacyText, levelText) {
    // doing the privacy decorating here so the punctuation can be different from the tooltip version
    const privacyTextFormatted = privacyText ? ` ${privacyText}` : '';
    return baseText + levelText + privacyTextFormatted;
  }
}
